import * as React from 'react';
import { useSelector } from 'react-redux';
import { Promo as PromoComponent } from '../../components/Promo';
import { PromoIntro } from '../../components/PromoIntro';
import { PromoPreview } from '../../components/PromoPreview';
import { useIsMortgageBrokerBannerAvailable } from '../../hooks/useIsMortgageBrokerBannerAvailable';
import { selectBlackFridayTopPromoSubtitle } from '../../selectors/blackFriday';
import { getNewbuildingId, getPromo, getPromosForPreview } from '../../selectors/newbuilding';
import { IPromo } from '../../types/newbuilding/promos';
import { trackClickPromoBlock } from '../../utils/analytics';
import { getPromoDate, getPromoIcon, getPromoSubtitle } from '../../utils/promos';
import { PromoDescriptionModalContainer } from '../PromoDescriptionModal';
import { PromoLink } from '../PromoLink';

export const Promo = () => {
  const [selectedPromo, setSelectedPromo] = React.useState<IPromo | null>(null);
  const isMortgageBrokerBannerAvailable = useIsMortgageBrokerBannerAvailable();
  const promo = useSelector(getPromo);
  const promosToPreview = useSelector(getPromosForPreview);
  const newbuildingId = useSelector(getNewbuildingId);
  const topPromoSubtitle = useSelector(selectBlackFridayTopPromoSubtitle);

  const closePromo = React.useCallback(() => {
    setSelectedPromo(null);
  }, []);

  const openPromo = React.useCallback(
    (promoInfo: IPromo) => {
      setSelectedPromo(promoInfo);
      trackClickPromoBlock(promoInfo, newbuildingId);
    },
    [newbuildingId],
  );

  const openMainPromo = React.useCallback(() => {
    openPromo(promo as IPromo);
  }, [promo, openPromo]);

  const promoDate = React.useMemo(() => getPromoDate(promo), [promo]);
  const promoIcon = React.useMemo(() => getPromoIcon(promo, true), [promo]);
  const promoSubtitle = React.useMemo(() => getPromoSubtitle(promo, topPromoSubtitle), [promo, topPromoSubtitle]);

  /* Если отображается баннер "Циан.Ипотека для профи", то скрываем блок */
  if (!promo || isMortgageBrokerBannerAvailable) {
    return null;
  }

  return (
    <>
      <PromoComponent
        promo={
          <PromoIntro
            dueDate={promoDate}
            name={promo.name}
            subtitle={promoSubtitle}
            onClick={openMainPromo}
            icon={promoIcon}
            isBlackFridayPromo={promo.isBlackFriday}
          />
        }
        link={<PromoLink />}
        previews={promosToPreview.length ? <PromoPreview promos={promosToPreview} onPromoClick={openPromo} /> : null}
      />
      {selectedPromo && <PromoDescriptionModalContainer open={true} onClose={closePromo} promo={selectedPromo} />}
    </>
  );
};
